var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 7,
    height: 7,
    rx: 1.5,
    stroke: "#292D32",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 2,
    height: 2,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 7,
    height: 7,
    rx: 1.5,
    stroke: "#292D32",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 4.5,
    width: 2,
    height: 2,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 7,
    height: 7,
    rx: 1.5,
    stroke: "#292D32",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 17.5,
    width: 2,
    height: 2,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15h2v2h-2z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15h3v2h-3z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h2v2h-2z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19h2v3h-2z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19h3v1.5h-3z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21.5h5V23h-5z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2h2v2h-2z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6v3h2V6z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11h3v2H2z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11h4v2H7z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11h4v2h-4z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11h3v2h-3z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2v3h-2z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20h2v2h-2z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeSvgrepoCom);
export default __webpack_public_path__ + "static/media/qr-code-svgrepo-com.58acfa60e4d855338fa8f9033805da3a.svg";
export { ForwardRef as ReactComponent };